import { render, staticRenderFns } from "./LoginV1.vue?vue&type=template&id=80940072"
import script from "./LoginV1.vue?vue&type=script&lang=js"
export * from "./LoginV1.vue?vue&type=script&lang=js"
import style0 from "./LoginV1.vue?vue&type=style&index=0&id=80940072&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports